import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-placeholder-table-settings',
  templateUrl: './placeholder-table-settings.component.html',
  styleUrls: ['./placeholder-table-settings.component.css'],
  imports: [CommonModule, MatIconModule]
})
export class PlaceholderTableSettingsComponent {

}
